import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CDrawingComponent } from './c-drawing.component';
import { ReactiveFormsModule } from '@angular/forms';

import { AsPipesModule } from '../../../pipes/as-pipes/as-pipes.module';

@NgModule({
  declarations: [CDrawingComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    AsPipesModule,
  ],
  exports: [CDrawingComponent]
})
export class CDrawingModule { }
